import {
  type CheckoutConfig,
  type HighnotePostMessageEvent,
  type CheckoutPostMessageEvent,
  type CheckoutReady,
  CheckoutPostMessageKind,
} from "@highnoteplatform/types";

import { iframeOrigin } from "./config";

export type OnReady = (event: CheckoutReady) => void;

export const createHandlePostMessage =
  (
    uuid: string,
    onTokenizeError: CheckoutConfig["onTokenizeError"],
    onTokenizeSuccess: CheckoutConfig["onTokenizeSuccess"],
    onReady: OnReady
  ) =>
  (
    event: MessageEvent<HighnotePostMessageEvent<CheckoutPostMessageEvent>>
  ): boolean => {
    if (event.origin !== iframeOrigin || uuid !== event.data.uuid) {
      return false;
    }

    const { data } = event.data;

    switch (data.kind) {
      case CheckoutPostMessageKind.TOKENIZE_SUCCCESS:
        onTokenizeSuccess(data);
        break;
      case CheckoutPostMessageKind.TOKENIZE_ERROR:
        onTokenizeError(data.error);
        break;
      case CheckoutPostMessageKind.CHECKOUT_READY:
        onReady(data);
        break;
      default:
        break;
    }

    return true;
  };
